import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  configureStandardMetrics,
  fetchStandardMetricsConfig,
} from '../../../services/queries/MaggieIntegrationsQueries';
import { StandardMetricsFormValues } from './standardMetricsConfig.schema';

export function useStandardMetricsConfigActions() {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['standard-metrics-config'],
    queryFn: fetchStandardMetricsConfig,
  });

  const mutation = useMutation({
    mutationFn: configureStandardMetrics,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['standard-metrics-config'] });
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
    },
  });

  const config = data ?? null;
  const isConnected = config?.isConnected ?? false;

  const saveConfig = useCallback(
    async (values: StandardMetricsFormValues) => {
      const result = await mutation.mutateAsync({
        clientId: values.clientId.trim(),
        clientSecret: values.clientSecret.trim() || undefined,
      });
      return result;
    },
    [mutation]
  );

  const resetConfig = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ['standard-metrics-config'] });
  }, [queryClient]);

  return { config, isConnected, isLoading, saveConfig, resetConfig };
}
